const FieldTitle = (function () {
  function titleFor(internalTitle, formId, index = null) {
    return index ? `${internalTitle}-${formId}-${index}` : `${internalTitle}-${formId}`;
  }

  return {
    titleFor
  };
}());

export default FieldTitle;



// WEBPACK FOOTER //
// ./components/common/fieldTitle.js